export interface CalendarLegendProps {
  youLabel?: string;
  themLabel?: string;
  pendingLabel?: string;
}

export function CalendarLegend({
  youLabel = 'You have kids',
  themLabel = 'Jose has kids',
  pendingLabel = 'Pending',
}: CalendarLegendProps) {
  return (
    <div className='mk-legend'>
      <span className='mk-legend__item'>
        <i className='mk-legend__dot mk-legend__dot--you' />
        {youLabel}
      </span>
      <span className='mk-legend__item'>
        <i className='mk-legend__dot mk-legend__dot--them' />
        {themLabel}
      </span>
      <span className='mk-legend__item'>
        <i className='mk-legend__dot mk-legend__dot--pending' />
        {pendingLabel}
      </span>
    </div>
  );
}
